'use client';

import { useSyncExternalStore } from 'react';

import dynamic from 'next/dynamic';

import { isDevPanelHost } from './isDevPanelHost';
import { readPanelDismissed } from './settings/devPanelStorage';

const DevPanel = dynamic(
  () => import('./DevPanel').then(module => module.DevPanel),
  { ssr: false },
);

function subscribeToNothing(): () => void {
  return () => {};
}

function readIsDevPanelHost(): boolean {
  return (
    isDevPanelHost(window.location.hostname, window.top === window.self) &&
    !readPanelDismissed()
  );
}

function readOnServer(): boolean {
  return false;
}

export function DevPanelGate() {
  const enabled = useSyncExternalStore(
    subscribeToNothing,
    readIsDevPanelHost,
    readOnServer,
  );

  return enabled ? <DevPanel /> : null;
}
